import axios from 'axios';

const API_URL = 'https://station-find-bke.onrender.com/api/states';
// const API_URL = 'http://localhost:5000/api/states';
export const getStates = async () => {
  try {
    const response = await axios.get(API_URL);
    return response.data;
  } catch (error) {
    console.error('Error fetching States:', error);
    throw error;
  }
};